export const scrollTo = (id) => {
  const titleElement = document.getElementById(id)
  titleElement.scrollIntoView({ behavior: 'smooth' })
}